// src/pages/SalesReturnLedger/SalesReturnLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSalesReturnLedger,
  fetchSaleReturnAccounts,
} from "./SalesReturnLedgerThunk";

const initialState = {
  list: [],
  accounts: [],
  loading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const salesReturnLedgerSlice = createSlice({
  name: "salesReturnLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalesReturnLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSalesReturnLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchSalesReturnLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchSaleReturnAccounts.pending, (state) => {
        state.loadingAccounts = true;
      })
      .addCase(fetchSaleReturnAccounts.fulfilled, (state, action) => {
        state.loadingAccounts = false;
        state.accounts = action.payload;
      })
      .addCase(fetchSaleReturnAccounts.rejected, (state) => {
        state.loadingAccounts = false;
      });
  },
});

export const { setFilters } = salesReturnLedgerSlice.actions;
export default salesReturnLedgerSlice.reducer;
